module.exports = __webpack_public_path__ + "/bundle/asset/relation-a40a014794a1fa01160d17df4aa9a862.png";